<div data-test="7dLLkEr2" class="page-wrap">
  <div
    data-test="S1V0M1Qm"
    class="login"
    style="background-image: url('assets/img/content/main-bg.png')"
  >
    <div data-test="c5jVEPZ7" class="container-fluid">
      <div data-test="6InF14Wn" class="login__wrap row">
        <div
          data-test="3k9Nq8YU"
          class="login__left col"
          style="background-image: url('assets/img/content/main-bg.png')"
        >
          <div data-test="kbf_RHbO" class="overlay"></div>
          <div data-test="uhFcoo3I" class="login__left-content">
            <img data-test="N_IRVzkr" src="assets/img/content/macs-logo.svg" alt="" />
            <div data-test="_WMR6xvd" class="login__left-text">
              <div data-test="IsDLK9wQ" class="login__title">MACS</div>
              <div data-test="1BWB8MKo" class="login__subtitle">
                Simplify your business process
              </div>
            </div>
          </div>
        </div>
        <div data-test="ZiRd3a-c" class="login__right col-auto">
          <header data-test="wAnjeUxa" class="login__right-header">
            <!--
            <img class="logo" src="assets/img/content/logo.svg" alt="" />
            -->
          </header>
          <router-outlet data-test="obwhyF-P"></router-outlet>
        </div>
      </div>
    </div>
  </div>
</div>
